<template>
  <div>
    <div v-for="(file, index) in invoiceAttachments" :key="index">
      <div v-if="pdfFile(file)" class="invoice-description-pdf">
        <iframe class="invoice-description-pdf-iframe" :src="file.original" />
        <div class="invoice-file-link px-i">
          <h3 class="invoice-file-link-text">
            {{ fileNameFromUrl(file.original) }}
          </h3>
          <a :href="file.original" target="_blank" class="btn btn-primary ihjoz-button flex-shrink-0">View PDF</a>
        </div>
      </div>
      <div v-else class="invoice-description-images">
        <div class="invoice-file">
          <img :src="file.display" class="invoice-file-image">
          <div class="invoice-file-link px-i">
            <h3 class="invoice-file-link-text">
              {{ fileNameFromUrl(file.original) }}
            </h3>
            <a :href="file.original" download class="btn btn-primary ihjoz-button flex-shrink-0">Download</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AttachedFiles",

  props: {
    invoiceAttachments: { type: Array }
  },

  methods: {
    fileNameFromUrl (url) {
      return url.split("/").pop();
    },

    pdfFile (file) {
      return file.original.split(".").pop() === "pdf";
    }
  }
};
</script>
